export default function Fallback() {
  return (
    "Domain not configured"
  )
}